// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"406":"38dbc778","953":"4fb32fd3"}[chunkId] + ".css";
};